import { Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { Resources } from './../../../../../models/resources';
import { UserService } from 'src/app/services/user.service';
import { Component, OnInit } from '@angular/core';
import { Role, UserResources } from 'src/app/models';
import * as jquery from 'jquery';
import * as AOS from 'aos';
import { StateChange } from 'ng-lazyload-image';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import { map, tap } from 'rxjs/operators';
import { ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { PortfolioNavigationComponent } from 'src/app/partials/navigation/portfolio-navigation/portfolio-navigation.component';

declare var require: any;

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(PortfolioNavigationComponent) portfolioNavigation;

  resourceType = 'science';
  resources: Resources[] = [];
  resourcesRaw: UserResources[] = [];
  modalText = 'Loading...';
  preloaderImage = require('../../../../../../assets/images/loader-big.svg');
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  constructor(
    private userService: UserService,
    private adminService: AdminService,
    public authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    AOS.init();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.getUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.getAdmin();
          } else {
            this.getUser();
          }
        });
    }

  }

  private getUser() {
    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResources();
          }
        },
        error => { }
      );
  }

  private getAdmin() {
    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.portfolioNavigation.user = user;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            this.getResources();
          }
        },
        error => { }
      );
  }

  private getResources(): void {

    this.showProgressModal();

    this.userService.getResources(this.resourceType)
      .subscribe(response => {
        this.resourcesRaw = response.data.resources;

        this.resourcesRaw.forEach(category => {
          category.resources.forEach(resource => {
            this.resources.push(resource);
          });
        });

        setTimeout(() => {
          this.setBoxMaximumHeight();          
        }, 1000);

        this.hideProgressModal();
      });
  }

  moduleImageCallback(event: StateChange, resourceId: number) {
    switch (event.reason) {
      case 'setup':
        // The lib has been instantiated but we have not done anything yet.
        const imageContainerOnInit: HTMLElement = document.getElementById('module_image_' + resourceId);
        imageContainerOnInit?.classList.add('module-image-loading');
        break;
      case 'observer-emit':
        // The image observer (intersection/scroll observer) has emit a value so we
        // should check if the image is in the viewport.
        // `event.data` is the event in this case.
        break;
      case 'start-loading':
        // The image is in the viewport so the image will start loading
        break;
      case 'mount-image':
        // The image has been loaded successfully so lets put it into the DOM
        break;
      case 'loading-succeeded':
        // The image has successfully been loaded and placed into the DOM
        const imageContainerAfterInit: HTMLElement = document.getElementById('module_image_' + resourceId);
        imageContainerAfterInit?.classList.remove('module-image-loading');
        imageContainerAfterInit?.classList.add('module-image-fit');

        // Module Points
        const moduleBadgePointsContainer: HTMLElement = document.getElementById('module_badge_points_' + resourceId);
        moduleBadgePointsContainer?.classList.remove('d-none');
        moduleBadgePointsContainer?.classList.add('d-flex');

        break;
      case 'loading-failed':
        // The image could not be loaded for some reason.
        // `event.data` is the error in this case
        break;
      case 'finally':
        // The last event before cleaning up
        break;
    }
  }

  saveResourcePoints(resourceId: number, type: string): void {
    this.userService.saveResourcePoints(resourceId)
      .subscribe(response => {
        this.portfolioNavigation.user = response.user;

        if (type === 'video') {
          this.router.navigate(['/user/resources/' + this.resourceType + '/' + resourceId]);
        }

      });
  }

  private setBoxMaximumHeight() {
    let maxHeight = 0;
    jquery('.module-info').each(function() {
        if (jquery(this).height() > maxHeight) {
          maxHeight = jquery(this).height();
        }
    });
    jquery('.module-info').height(maxHeight);
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
